import { Grid } from '@mui/material';

import { MenuContainer } from '@components/Menu/Menu.container';
import { RouterManager } from '@router/RouterManager';

export const App = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <MenuContainer />
      </Grid>
      <Grid item xs={12} md={8}>
        <RouterManager />
      </Grid>
    </Grid>
  );
};
